<div class="tour-list cbw-tour-list">
  @for (group of groups(); track group.id; let i = $index) {
    <div class="tour-list__group cbw-tour-list-group" role="group" [attr.aria-label]="group.name">
      <div class="tour-list__group-header cbw-tour-list-group-header">{{ group.name }}</div>
      <div class="tour-list__group-body">
        @for (service of group.services; track service.id) {
          <app-tour-service-card
            [service]="service"
            [isSelected]="selectedIds().has(service.id)"
            [isDisabled]="disabledIds().has(service.id)"
            [widgetTemplates]="widgetTemplates()"
            [lang]="lang()"
            (toggle)="onToggle(service.id)"
            (viewAbsences)="onViewAbsences($event)"
          />
        }
      </div>
    </div>

    @if (nextGroup(i); as next) {
      @if (plantTravelPills().has(pillKey(group.id, next.id))) {
        <div class="tour-list__pill-wrapper" aria-hidden="true">
          <div class="tour-list__pill cbw-tour-list-pill">
            <fa-icon [icon]="['fas', 'route']" />
            <span>
              {{ 'tour_widget.travel_time_pill' | translate:{ min: plantTravelPills().get(pillKey(group.id, next.id)) } }}
            </span>
          </div>
        </div>
      }
    }
  }
</div>
